/**
 * Configuración global de endpoints
 * Se adjuntan a la API_BASE_SRC
 * Ej: API_BASE_SRC + '/' + endpoints.EJEMPLO
 */
export const ACORTAR_URL = "utils/sUrl";
export const TOKENIZAR_USER = "customer/tokenize";
export const CONSULTAR_HASH = "ventaTC/wp/generarHashReferidos";
export const CONSULTAR_PREMIOS = "ventaTC/wp/premiosPorCampania";
export const CONSULTAR_OFERTA = "ventaTC/wp/obtenerPremiosReferente";
export const CONSULTAR_CAMPANIA = "ventaTC/wp/obtenerCampaniasReferente";
export const AEM_CAMPAIGN = "aem/cargarCampaniasAEM";
